import type React from "react"
import classNames from "classnames"
import { Img } from "components"
import { ReactNode } from "react"
import Text from "./Text"

type Features = {
  title: string | React.ReactNode
  description: string | React.ReactNode
  cta?: string | React.ReactNode
  imageAlt?: string
  imageQuery?: string
  reverse?: boolean
  badge?: ReactNode;
  rightSideElement?: ReactNode;
  imgClassNames?: string;
  mainClasses?: string;
}

export function Feature({
  title,
  description,
  cta,
  imageAlt,
  imageQuery,
  reverse,
  badge,
  rightSideElement,
  imgClassNames,
  mainClasses
}: Features) {
  return (
    <section
      className={classNames(
        "grid items-center gap-8 grid-cols-2 bg-[white] rounded-xl p-6 md:mx-2 my-12",
        "md:grid-cols-1 md:gap-6",
        "sm:gap-5",
        mainClasses
      )}
    >
      {/* Text column */}
      <div className={classNames(
        "flex flex-col gap-4 w-[90%]",
        "md:w-full md:order-1 md:text-center",
        reverse ? "order-2" : "order-1",
      )}>
        <div className="space-y-2">
          {/* {!!badge && (typeof badge === "string" ? <Text type="highlighter" label={badge?.toUpperCase()} /> : badge)} */}
          <h3 className="text-[#181818] text-pretty text-4xl font-semibold tracking-tight md:text-3xl sm:text-2xl">
            {typeof title === "string" ? <Text type="cardTitle" label={title} /> : title}
          </h3>
        </div>
        <div className="text-sm leading-6 text-[#4D4D4D] sm:text-xs sm:leading-5">
          {typeof description === "string" ? <Text type="description" label={description} /> : description}
        </div>
        {!!cta && cta}
      </div>
      {/* Illustration / card column */}
      <div className={classNames(
        "relative",
        "md:order-2",
        reverse ? "order-1" : "order-2"
      )}>
        <div className={classNames(
          "relative w-full overflow-hidden rounded-xl",
          "bg-card",
          "sm:rounded-lg"
        )}>
          {/* Soft glassy background using placeholder image */}
          {!!imageQuery && <Img
            alt={imageAlt}
            src={`${imageQuery}`}
            className={classNames("object-cover w-full h-full scale-1",imgClassNames)}
          />}
          {!!rightSideElement && rightSideElement}
          {/* Subtle inset border for polish */}
          {/* <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-border/60 sm:rounded-lg" /> */}
        </div>
      </div>
    </section>
  )
}